import React from "react";
import { MessageSquare } from "lucide-react";

const MINT = "#10b981";
const PURPLE = "#a855f7";

const ChatEmptyState = () => (
  <div className="relative grid h-full w-full place-items-center bg-[#07060d] p-8">
    <div
      className="pointer-events-none absolute left-1/2 top-1/2 h-80 w-80 -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl"
      style={{ background: PURPLE, opacity: 0.08 }}
    />
    <div className="relative max-w-sm rounded-3xl border border-white/10 bg-white/[0.03] px-8 py-10 text-center backdrop-blur-xl">
      <div
        className="mx-auto mb-5 grid h-14 w-14 place-items-center rounded-2xl border border-white/10 bg-white/5"
        style={{
          color: MINT,
          boxShadow: `0 16px 40px -16px ${MINT}, inset 0 0 0 1px rgba(16,185,129,0.15)`,
        }}
      >
        <MessageSquare size={22} />
      </div>
      <h2 className="text-lg font-semibold tracking-tight text-white">
        Select a conversation
      </h2>
      <p className="mt-2 text-sm text-white/50">
        Choose a chat from the sidebar to start messaging.
      </p>
    </div>
  </div>
);

export default ChatEmptyState;
